import { Create, CreateProps } from '@refinedev/antd';
import { EmptyState } from 'components/EmptyState';
import { ReactNode } from 'react';

interface CreateLayoutProps<T> extends CreateProps {
  children: ReactNode;
  backLabel?: ReactNode;
  isLoading?: boolean;
  isFetched?: boolean;
  record?: T;
  EmptyStateComponent?: ReactNode;
}

export const CreateLayout = <T,>({
  children,
  isLoading,
  isFetched,
  record,
  EmptyStateComponent = <EmptyState description="Nenhum dado encontrado" />,
  ...props
}: CreateLayoutProps<T>) => {
  const renderContent = () => {
    if (isFetched && !isLoading && !record) {
      return EmptyStateComponent;
    }

    return children;
  };

  return (
    <Create
      headerButtonProps={{
        hidden: true
      }}
      footerButtonProps={{
        style: {
          float: 'right'
        }
      }}
      wrapperProps={{
        className: 'custom-layout'
      }}
      contentProps={{
        className: `!bg-transparent !shadow-none [&_.custom-card]:border-b-0
        ${
          props.footerButtonProps?.hidden
            ? '[&_.custom-card]:rounded-b-md [&_.custom-card-body]:rounded-b-md'
            : '[&_.custom-card]:rounded-b-none [&_.custom-card-body]:rounded-b-none'
        }
       `,
        styles: {
          body: {
            padding: 0,
            backgroundColor: 'transparent'
          },
          actions: {
            height: !!props.footerButtonProps?.hidden ? 0 : 'auto',
            borderTop: !!props.footerButtonProps?.hidden
              ? 0
              : '1px solid #f0f0f0',
            borderColor: '#f0f0f0',
            padding: '0 24px'
          }
        }
      }}
      {...props}
    >
      {renderContent()}
    </Create>
  );
};
